// import Cookies from "universal-cookie";
import { axiosInstanceAuth } from "../../Utils/AxiosInstance";
import { handleApiError } from "../../Utils/handleApiError";
// const cookies = new Cookies();

export const LoginApi = async data => {
  let snackBarData = {};
  try {
    let response = await axiosInstanceAuth.post("/Auth/Login", data);

    if (response.data.IsSuccess) {


      sessionStorage.setItem("access_token", response.data.Token);
      sessionStorage.setItem("guide", response.data.IsGuide);

      snackBarData = {
        type: "success",
        message: response.data.Message,
        openToast: true,
      };

      return { ...response, snackBarData };
    } else {
      snackBarData = {
        type: "error",
        message: response?.data?.Message,
        openToast: true,
      };
      return { ...response, snackBarData };
    }
  } catch (error) {
    // snackBarData = {
    //   type: "error",
    //   message: error?.response?.data?.Message || error?.message,
    //   openToast: true,
    // };
    const snackBarData = handleApiError(error);
    return { ...error, snackBarData };
  }
};
